import styled from 'styled-components';

import {
  spacing16,
  spacing4,
  ValidSpacings,
} from 'approot/shared/styles/spacing.style';
import { LabelStyled } from 'approot/shared/styles/inputs.style';
import {
  font14,
  fontWeightBold,
  PStyled,
} from 'approot/shared/styles/typography.style';
import { HrStyled } from 'approot/shared/styles/decorative.style';
import { Box } from 'approot/shared/styles/box.style';

export const SettingsLabel = styled(LabelStyled).attrs({
  marginBottom: spacing4,
  'data-selector': 'settings-label',
})``;

export const SettingsGroup = styled(Box).attrs<{
  'data-selector'?: string;
  marginBottom: ValidSpacings;
}>(({ marginBottom = 24, ...rest }) => ({
  'data-selector': 'settings-group',
  $flexDirection: 'column',
  $marginBottom: marginBottom,
  ...rest,
}))`
  position: relative;
`;

export const SettingsHr = styled(HrStyled).attrs(
  ({ marginTop = 0, marginBottom = spacing16 }) => ({
    marginTop,
    marginBottom: marginBottom,
  })
)`
  width: 100%;
`;

export const SettingSmallText = styled(PStyled)`
  ${font14}
`;

export const SettingSubHeading = styled.h2`
  ${font14}
  font-weight: ${fontWeightBold};
`;
